'use strict'

var App = require('app')

/* Views */
var Show = require('./show')

var DeviceStatus = function () {
  /* Routes ----------------------------------------------------------------- */
  /* API -------------------------------------------------------------------- */
  var API = {
    showStatus: function (options) {
      let show = new Show(options)
    }
  }

  /* Listeners -------------------------------------------------------------- */
  App.globalChannel.on('device-status:show', function (options) {
    API.showStatus(options)
  })
}

module.exports = DeviceStatus



// WEBPACK FOOTER //
// ./js/modules/device-status/index.js